import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
export function ScarcityBar() {
  // Starts near-full to signal urgency; drifts down slightly then holds.
  const [spots, setSpots] = useState(9);
  useEffect(() => {
    const t = setInterval(() => {
      setSpots(prev => prev > 4 ? prev - 1 : prev);
    }, 45000);
    return () => clearInterval(t);
  }, []);
  const pct = Math.max(6, Math.round(spots / 40 * 100)); // bar looks ~full

  return <div className="rounded-xl border border-[#f5a623]/40 bg-[#fff8ec] p-4" data-id="element-199" data-mp="2g6w884t4c186">
      <div className="mb-2 flex items-center justify-between gap-2" data-id="element-200" data-mp="226lgkzjziily">
        <span className="inline-flex items-center gap-1.5 font-head text-sm font-800 text-[#c47d09]" data-id="element-201" data-mp="228erws5jlr0a">
          <FlameIcon className="h-4 w-4 text-[#f5a623]" data-id="element-202" data-mp="276zpejtetwl1" />
          ¡Cupos casi agotados!
        </span>
        <span className="text-sm font-700 text-[#0f2547]" data-id="element-203" data-mp="5ds0qjrwq2mh">
          Faltan <span className="text-[#c47d09]" data-id="element-204" data-mp="5d0h87bl3vck">{spots} cupos</span>
        </span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-[#f0e2c8]" data-id="element-205" data-mp="33lbqot90v03y">
        <motion.div initial={{
        width: "100%"
      }} animate={{
        width: `${100 - pct}%`
      }} transition={{
        duration: 0.8
      }} className="h-full rounded-full bg-gradient-to-r from-[#f5a623] to-[#ff8a00]" data-id="element-206" data-mp="2zk8bm8yst83s" />
      </div>
      <p className="mt-2 text-center text-xs font-500 text-slate-500" data-id="element-207" data-mp="38fxt46x4libw">
        para acceder al precio promocional de lanzamiento
      </p>
    </div>;
}